import { ISupplier } from "@evennt-tech/api-v2-core";

export enum CartProgress {
  CART = 0,
  PAYMENT,
}
export enum PaymentProgress {
  DETAILS = 0,
  CARD_DETAILS,
}

export type BillingDetails = {
  tradingName: string;
  status: "received";
  name: string;
  vat: string;
  address: string;
  postCode: string;
  contact: string;
  contactPhoneNumber: number;
  contactEmail: string;
};

export type CartWithApprovalAmount = {
  [key: ISupplier["id"]]: number;
} | null;
export type CartTotalAmount = {
  withApproval: CartWithApprovalAmount;
  withoutApproval: number;
};

export type ExhibitorCartStatus = {
  checkoutProgress: CartProgress;
  detailsProgress: PaymentProgress;
  billingDetails: BillingDetails;
  totalAmount: CartTotalAmount;
};
